import {useMutation, UseMutationResult, useQueryClient} from '@tanstack/react-query';
import {fundRepresentativesApi} from '../api';
import {CreateFundRepresentativeDTO} from '../model';
import {useNotifications} from '../../../shared';

// Тонкий хук только с мутацией создания — без списочного query.
// Используется там, где нужен лишь createMutation (форма добавления),
// чтобы не инициировать лишний GET /fund-representatives.
export const useCreateFundRepresentative = (): UseMutationResult<
  unknown,
  Error,
  CreateFundRepresentativeDTO
> => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();

  return useMutation({
    mutationFn: fundRepresentativesApi.create,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['fund-representatives']});
      createNotification({
        title: 'Представитель Фонда успешно создан',
        name: 'createFundRepresentative',
        theme: 'success',
      });
    },
  });
};
